import {CreateProps} from "react-admin";
import {CustomCreate} from "../components/CustomCreate";
import {TagForm} from "./TagForm";


export const TagCreate = (props: CreateProps) => {

    return (
        <CustomCreate {...props}>
            <TagForm />
        </CustomCreate>
    )

}